import { KoobMapMarker } from '@koob/maps';

interface TripMapItineraryProgramMarkerProps {
  label?: string;
  program?: {
    startPosition?: {
      lat?: number | string | null;
      lon?: number | string | null;
    };
    title?: string;
  };
  icon: string;
}

export default function TripMapItineraryProgramMarker({
  label,
  program,
  icon,
}: TripMapItineraryProgramMarkerProps) {
  return (
    <KoobMapMarker
      lat={program?.startPosition?.lat ?? ''}
      lng={program?.startPosition?.lon ?? ''}
      label={label}
      icon={icon}
      title={program?.title}
      popup={<p className="py-3 pl-3 pr-10">{program?.title}</p>}
    />
  );
}
